
import { defineComponent } from 'vue';
import _ from 'lodash';
import {_Util} from "../MyUtil";
import { _ServerApi } from '@/serverAPI';


//import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'HomeView',
  data(){
    return {
      "util" : _Util.getInstance(),
      "test1" : "test msg",
      "email" : "",
      "password" : "",
    }
  },
  components: {
  },
  
  methods:{
    "test" : function() : string {
      return "test";
    },
    alert(msg:string) :void {
      this.util.alert({
        vue_ele:this.$root,
        title : "안내",
        msg : msg      });
    },
    async login() : Promise<void> {
      try{

        var util = this.util;

        if(!util.isEamilString(this.email)){
          this.alert("이메일 주소를 확인 하세요");
          return;
        }
        if(this.password == ""){
          this.alert("패스워드를 확인 하세요.");
          return;
        }
        var _s = _ServerApi.getInstance();
        util.setLoading({
          vue_ele:this.$root,
          isLoading:true
        });
        var result = await _s.postJson("/api/login",{"email" : this.email,"password" : this.password});
        await util.waitTime(500);
        
        if(result.isError){
          this.alert(result.msg);
          util.setLoading({
            vue_ele:this.$root,
            isLoading:false
          });
          return;
        }
        //this.alert("....");
        location.href ="/";

        
      }
      catch(e){
        console.error(e);
        return;
      }
      
      return;
    }
  },
  
  mounted() {


    let meta = this.$router.currentRoute.value.meta;
    if(_.isString(meta.title)){
      document.title = meta.title;
    }
    
  },
  
});
